//@ts-nocheck
import React, { Suspense, useEffect, useState } from 'react'
import {
  AppBar,
  Toolbar,
  IconButton,
  Icon,
  Box,
  MenuItem,
  Menu,
  InputAdornment,
  FormControl,
  InputLabel,
  Input,
  Select,
  Typography,
  Breadcrumbs,
  Link
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close';
import { makeStyles } from 'tss-react/mui'
import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined'
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined'
import BulkUpload from '../BulkUpload'
import { useNavigate } from 'react-router-dom'
import AdminInstallerForm from '../AdminInstallerForm'
import CountryOnboarding from '../CountryOnboarding'
import Loading from '../Loading';
import { useGlobalStateContext } from '../../context/globalState';
import { hasPermission } from '../../utils/apiUtils';
import TextLabel from '../TextLabel';
import { useTranslation } from 'react-i18next';
import { FileDownload, FileDownloadDoneOutlined, FileDownloadOffOutlined, FileDownloadOutlined, NavigateNext } from '@mui/icons-material';
import { capitalizeFirstLetter } from '../helper';

// Lazy, matching how ScrollableTable pulls it in: the grid carries its own
// reference data and styles, and most visits to this header never open it.
const BulkOnboardingGrid = React.lazy(() => import('../BulkOnboardingGrid'));

const useStyles = makeStyles()((theme) => ({
  root: {
    flexGrow: 1,
    border: 'none'
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
}))
interface Proptype {
  handleSearch: () => void;
  handleBreadcrumbClick: () => void;
  renderAddInstallerForm: () => void;
  setShowBulkUploadForm: (show: boolean) => void;
  showBulkUploadForm: boolean;
  adminRole?: string;
  countryList?: any[];
}
const SubHeader = ({ handleSearch,handleBreadcrumbClick,  renderAddInstallerForm, showBulkUploadForm, setShowBulkUploadForm, adminRole, countryList = [] }: Proptype) => {
  // Import global state context
  const { bulkUploadStatus, setBulkUploadStatus, bulkUploadMode, setBulkUploadMode, breadcrumbs, permissions } = useGlobalStateContext()
  const { t } = useTranslation();

  // Define state variables
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [showInstallerForm, setShowInstallerForm] = useState(false);
  const [showSearchField, setShowSearchField] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const [searchKey, setSearchKey] = useState(false);
  const [showCountryOnboarding, setShowCountryOnboarding] = useState(false);
  const [showBulkOnboarding, setShowBulkOnboarding] = useState(false);

  /**
   * Country field configuration, gated on the permission rather than the role.
   *
   * Identical in effect today - only SUPER_ADMIN_USERS holds '*' - but a group
   * given 'admin:country:config' later gets the screen without a release. Note
   * the save itself carries a second, deliberate super-admin check on the
   * server, because it runs DDL; reading the configuration does not.
   */
  const canConfigureCountry = hasPermission(permissions, 'admin:country:config');
  // Auth0 subcontractor admin. Vendor-fenced on the server, so they can only
  // ever onboard their own subcontractor employees.
  const isSubconAdmin = adminRole === 'SUBCON_ADMIN';
  /**
   * Whether to offer the bulk grid, decided by what the backend granted.
   *
   * Either capability is enough to open it - the grid holds both modes and
   * disables the one the caller cannot use. No AD group is named here: the
   * server is the enforcement, and this only avoids offering a screen whose
   * every action would come back 403. Granting a group access is a row in
   * ad_group_permissions, not a change to this file.
   */
  const canBulkOnboard =
    hasPermission(permissions, 'admin:user:bulkCreate') ||
    hasPermission(permissions, 'admin:user:bulkUpdate');

  const open = Boolean(anchorEl);
  const navigate = useNavigate();
  const { classes } = useStyles()

  useEffect(() => {
    if (bulkUploadStatus) {
      setShowBulkUploadForm(false);
    }
  }
    , [bulkUploadStatus])

  const handleRedirect = (event: { currentTarget: React.SetStateAction<null> }) => {
    setAnchorEl(event.currentTarget);
  }
  const handleShowSupervisorForm = () => {
    setShowSupervisorForm(true)
  }
  const handleShowInstallerForm = () => {
    renderAddInstallerForm()
  }
  const handleShowCompanyForm = () => {
    setShowCompanyForm(true)
  }

  const onBlurSearchInput = () => {
    !searchValue && hideSearchInput();
  }

  const hideSearchInput = () => {
    setShowSearchField(false);
    setSearchValue('');
    setSearchKey(false);
    // Call the handleSearch function with an empty string to clear the search value
    handleSearch(''); // Clear the search value
  }

  const showSearchInput = () => {
    setShowSearchField(true);
  }

  const onChangeSearchInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(event.target.value);
  }

  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      searchHandler();
    }
  };

  const searchHandler = () => {
    if (searchValue) {
      handleSearch(searchKey, searchValue);
    } else {
      alert(t('searchMessages.emptySearchAlert'));
    }
  }
  const searchOptions = [
    { value: 'supplierName', label: 'Supplier Name' },
    { value: 'supplierCity', label: 'Supplier City' },
    { value: 'supplierId', label: 'Supplier ID' },
    { value: 'supplierPostalCode', label: 'Supplier Postal Code' },
    { value: 'supplierCompanyCode', label: 'Supplier Company Code' },
    { value: 'userName', label: 'User Name' },
    { value: 'userId', label: 'User ID' },
    { value: 'userEmail', label: 'User Email' },
    {value:'assessorName', label:'Manager Name'},
  ];


  const handleUploadIconClick = () => {
    setBulkUploadStatus(false); // reset bulk upload status
    setBulkUploadMode('upload'); // set to upload mode
    setShowBulkUploadForm(true); // always show the bulk upload form
  };
  
  const handleDownloadIconClick = () => {
    setBulkUploadStatus(false); // reset bulk upload status
    setBulkUploadMode('download'); // set to download mode
    setShowBulkUploadForm(true); // always show the bulk upload form
  };

  const renderBreadcrumbs = () => <>
    <Breadcrumbs
      separator={<NavigateNext fontSize="small" />}
      aria-label="breadcrumb"
      cursor="pointer"
    >
      {breadcrumbs.map((breadcrumb, index) => (
        <Link underline='none' key={index} color="inherit" key={`link-${breadcrumb.label}-${index}`} href='/' onClick={(event) => { event.preventDefault(); handleBreadcrumbClick(breadcrumb.key, breadcrumb.value) }}>
          <TextLabel type='tableHeader' sxStyles={{ color: 'text.primary' }} key={`textlabel-${breadcrumb.label}-${index}`} cursor="pointer" id={`breadcrumb-${breadcrumb.label}-${index}`}>
                {capitalizeFirstLetter(breadcrumb.label)}
            </TextLabel>
        </Link>
      ))}
    </Breadcrumbs></>


  return (
    <div className={classes.root}>
      <AppBar position="static" color="transparent">
        <Toolbar>
          {/* <Icon sx={{ marginLeft: 40, color: '#0000FF' }}>
            <ViewListTwoToneIcon sx={{ fontSize: 30 }} />
          </Icon>
          <Icon color="inherit">
            <BarChartIcon sx={{ fontSize: 40 }} />
          </Icon> */}

          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'center',
              padding: '8px',
              width: '100%',
              border: 'none',
              marginLeft: '100px',
            }}
          >
            {renderBreadcrumbs()}
          </Box>

          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
              padding: '8px',
              width: '100%',
              border: 'none',
            }}
          >
            {showSearchField ?
              <Box sx={{ '& > :not(style)': { m: 1 } }}>

                <FormControl variant="standard" sx={{ minWidth: 120 }}>
                  <InputLabel id="demo-simple-select-label"><TextLabel type='smallText'>{t('adminDashboard.search.label.searchFor')}</TextLabel></InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={searchKey}
                    onChange={(event) => setSearchKey(event.target.value as boolean)}
                  >

                    {searchOptions.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        <TextLabel type='regularText'>{t(`adminDashboard.search.options.${option.value}`) || option.label}</TextLabel>
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControl variant="standard">
                  <InputLabel htmlFor="input-with-icon-adornment">
                    <TextLabel type='smallText'>{t('adminDashboard.search.label.search')}</TextLabel>
                  </InputLabel>
                  <Input
                    id="search-input-with-icon-adornment"
                    value={searchValue}
                    placeholder={t('adminDashboard.search.placeholder.search')}
                    onChange={onChangeSearchInput}
                    onBlur={onBlurSearchInput}
                    onKeyPress={handleKeyPress}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          onClick={hideSearchInput}
                        >
                          <CloseIcon />
                        </IconButton>
                      </InputAdornment>
                    }
                    startAdornment={
                      <InputAdornment position="start">
                        <IconButton
                          onClick={searchHandler}
                        >
                          <img src='/icon_search.jpg' style={{
                            fontFamily: 'var(--unnamed-font-family-inter)',
                            fontStyle: 'var(--unnamed-font-style-normal)',
                            fontWeight: 'var(--unnamed-font-weight-normal)',
                            fontSize: 'var(--unnamed-font-size-14)',
                            lineHeight: 'var(--unnamed-line-spacing-32)',
                            letterSpacing: 'var(--unnamed-character-spacing-0)',
                            color: 'var(--unnamed-color-1450f5)'
                          }} />
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </FormControl>

              </Box> :
              <IconButton color="inherit" onClick={showSearchInput}>
                <img src='/icon_search.jpg' style={{
                  fontFamily: 'var(--unnamed-font-family-inter)',
                  fontStyle: 'var(--unnamed-font-style-normal)',
                  fontWeight: 'var(--unnamed-font-weight-normal)',
                  fontSize: 'var(--unnamed-font-size-14)',
                  lineHeight: 'var(--unnamed-line-spacing-32)',
                  letterSpacing: 'var(--unnamed-character-spacing-0)',
                  color: 'var(--unnamed-color-1450f5)'
                }} />
              </IconButton>}

            <IconButton color="inherit" onClick={handleRedirect}>
              <img src='/icon_add_new.jpg' style={{
                fontFamily: 'var(--unnamed-font-family-inter)',
                fontStyle: 'var(--unnamed-font-style-normal)',
                fontWeight: 'var(--unnamed-font-weight-normal)',
                fontSize: 'var(--unnamed-font-size-14)',
                lineHeight: 'var(--unnamed-line-spacing-32)',
                letterSpacing: 'var(--unnamed-character-spacing-0)',
                color: 'var(--unnamed-color-1450f5)'
              }} />
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              open={open}
              onClose={() => setAnchorEl(null)} // Close the menu if clicked outside
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
              }}
            >
              <MenuItem onClick={handleShowInstallerForm}><TextLabel type='regularText'>{t('adminDashboard.form.button.createNewPassport')}</TextLabel></MenuItem>
              {canConfigureCountry && (
                <MenuItem
                  onClick={() => {
                    setAnchorEl(null);
                    setShowCountryOnboarding(true);
                  }}
                >
                  <TextLabel type='regularText'>{t('countryOnboarding.menuItem')}</TextLabel>
                </MenuItem>
              )}
              {canBulkOnboard && (
                <MenuItem
                  onClick={() => {
                    setAnchorEl(null);
                    setShowBulkOnboarding(true);
                  }}
                >
                  <TextLabel type='regularText'>{t('bulkOnboarding.menuItem')}</TextLabel>
                </MenuItem>
              )}
            </Menu>

            {canConfigureCountry && showCountryOnboarding && (
              <CountryOnboarding
                open={showCountryOnboarding}
                onClose={() => setShowCountryOnboarding(false)}
              />
            )}

            {canBulkOnboard && showBulkOnboarding && (
              <Suspense fallback={<Loading />}>
                <BulkOnboardingGrid
                  open={showBulkOnboarding}
                  onClose={() => setShowBulkOnboarding(false)}
                  subconOnly={isSubconAdmin}
                />
              </Suspense>
            )}

            <IconButton color="inherit" onClick={handleUploadIconClick}>
              <FileUploadOutlinedIcon sx={{ fontSize: 25 }} />
            </IconButton>
            <IconButton color="inherit" onClick={handleDownloadIconClick}>
              <FileDownloadOutlined sx={{ fontSize: 25 }} />
            </IconButton>
          </Box>
        </Toolbar>
      </AppBar>
    </div>
  )
}
export default SubHeader
